import { render, staticRenderFns } from "./price-tabs.vue?vue&type=template&id=3a07f1c9"
import script from "./price-tabs.vue?vue&type=script&lang=js"
export * from "./price-tabs.vue?vue&type=script&lang=js"
import style0 from "./price-tabs.vue?vue&type=style&index=0&id=3a07f1c9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports